/**
 * View component for /user-evaluations/:userEvaluationId/update
 *
 * Updates a single userEvaluation from a copy of the selcted userEvaluation
 * as defined in the userEvaluation reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as userEvaluationActions from '../userEvaluationActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import module components
import UserEvaluationForm from '../components/UserEvaluationForm.js.jsx';
import UserEvaluationLayout from '../components/UserEvaluationLayout.js.jsx';

// import userEvaluation css modules
import userEvaluationStyles from '../userEvaluationModuleStyles.css';

class UpdateUserEvaluation extends Base {
  constructor(props) {
    super(props);
    const { selectedUserEvaluation, userEvaluationMap } = this.props;
    this.state = {
      userEvaluation: userEvaluationMap[selectedUserEvaluation.id] ? { ...userEvaluationMap[selectedUserEvaluation.id] } : {}
      // NOTE: we don't want to change the store, just make changes to a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(userEvaluationActions.fetchSingleIfNeeded(match.params.userEvaluationId))
  }

  componentWillReceiveProps(nextProps) {
    const { selectedUserEvaluation, userEvaluationMap } = nextProps;
    this.setState({
      userEvaluation: userEvaluationMap[selectedUserEvaluation.id] ? { ...userEvaluationMap[selectedUserEvaluation.id] } : {}
      //we don't want to actually change the store's userEvaluation, just use a copy
    })
  }

  _handleFormChange(e) {
    let newUserEvaluationState = _.update( this.state.userEvaluation, e.target.name, function() {
      return e.target.value;
    });
    this.setState({userEvaluation :newUserEvaluationState});
  }

  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(userEvaluationActions.sendUpdateUserEvaluation(this.state.userEvaluation)).then((action) => {
      if(action.success) {
        history.push(`/user-evaluations/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { selectedUserEvaluation, userEvaluationMap } = this.props;
    const { userEvaluation } = this.state;
    const isEmpty = (!userEvaluation || userEvaluation._id === null || userEvaluation._id === undefined);
    return  (
      <UserEvaluationLayout>
        <div className="flex">
          <section className="section">
            {isEmpty ?
              (selectedUserEvaluation.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
              :
              <UserEvaluationForm
                userEvaluation={userEvaluation}
                cancelLink={`/user-evaluations/${userEvaluation._id}`}
                formTitle="Update User Evaluation"
                formType="update"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
              />
            }
          </section>
        </div>
      </UserEvaluationLayout>
    )
  }
}

UpdateUserEvaluation.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    selectedUserEvaluation: store.userEvaluation.selected
    , userEvaluationMap: store.userEvaluation.byId
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(UpdateUserEvaluation)
);



// WEBPACK FOOTER //
// modules/userEvaluation/views/UpdateUserEvaluation.js.jsx